// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.dqb-more-menu { min-width:185px; padding:6px;\n}\n.dqb-more-menu button { display:block; width:100%; padding:10px 12px; text-align:left; border:0; border-radius:6px; background:transparent; color:inherit; cursor:pointer;\n}\n.dqb-more-menu button:hover { background:#787b8618;\n}\n", ""]);
// Exports
module.exports = exports;
